import React, { useMemo } from "react";
import { Box, Flex } from "orcs-design-system";

import { sample } from "lodash";
import { Circle, Line } from "src/components/Placeholder/PlaceholderStyles";
import { SourceHandle, StyledCard, TargetHandle } from "../node.styled";

const PersonNodeSkeleton = () => {
  const randomNameLength = useMemo(() => sample([60, 80, 100, 120]), []);

  return (
    <StyledCard width="auto" minWidth="350px" maxWidth="350px" cursor="grab">
      <TargetHandle $hidden type="target" position="top" />
      <Flex flexDirection="column" gap="r">
        <Flex alignItems="center" gap="r">
          <Box>
            <Circle width={36} height={36} />
          </Box>
          <Flex alignItems="flex-start" flexDirection="column" gap="4px">
            <Flex alignItems="center" gap="xs">
              <Line width={randomNameLength} height={18} />
              <Line width={20} height={20} />
            </Flex>
            <Line width={30} height={16} />
          </Flex>
        </Flex>
        <Flex gap="xs">
          <Line width={30} height={16} />
          <Line width={60} height={16} />
        </Flex>
      </Flex>
      <SourceHandle $hidden type="source" position="bottom" />
      <TargetHandle $hidden type="target" position="top" />
    </StyledCard>
  );
};

export default PersonNodeSkeleton;
